export const aiPageConfig = {
  mainEvn: "mainEvn",
  subEvn: "subEvn",
  addNewMainEvnTitle: "新增主事件",
  addNewSubEvnTitle: "新增子事件",
  tableDataHeaderCh: [
    "原始資料",
    "起點 *",
    "終點 *",
    "主事件分類",
    "子事件分類",
    "關係",
    "",
  ],
  tableDataHeaderEn: [
    "source",
    "srcLabel",
    "dstLabel",
    "mainEvn",
    "subEvn",
    "relationship",
    "",
  ],
  excelHeaderCh: [
    "起點",
    "終點",
    "原始資料",
    "關係",
    "主事件分類",
    "子事件分類",
  ],
  excelHeaderEn: [
    "srcLabel",
    "dstLabel",
    "source",
    "relationship",
    "mainEvn",
    "subEvn",
  ],
  required: " *",
};
